// removed by extract-text-webpack-plugin
module.exports = {"container":"_7OnxxmMMSo2V9mvlC9-1w"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Createorganization/Main/styles.css
// module id = 3032
// module chunks = 0